export default __webpack_public_path__ + "static/media/upsellsetup.246628b1.svg";